module.exports = __webpack_public_path__ + "img/touxiang.e8b63c64.png";